import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@/core/model/api-response';
import { ChangePasswordModel, ProfileModel } from '@/core/model/profile.model';
import { environment } from '../../../environments/environment';

/**
 * SRP: owns only HTTP calls related to the logged-in user's own profile
 * (account details + password change) — distinct from AuthHttpService's
 * login/session concerns.
 */
@Injectable({ providedIn: 'root' })
export class ProfileHttpService {
    private readonly http = inject(HttpClient);
    private readonly url = environment.baseUrl;

    updateProfile(data: Partial<ProfileModel>) {
        return this.http.patch<ApiResponse<ProfileModel>>(`${this.url}/auth/profile`, data);
    }

    changePassword(data: ChangePasswordModel) {
        return this.http.post<ApiResponse<null>>(`${this.url}/auth/change-password`, data);
    }
}
